import { moreCompletionsNeededThanAvailableSlots } from 'shared/helpers/functional'
import * as types from 'store/currentProject/currentProjectTypes'

const initialState = {
  showCopyLinkButton: false,
  conferenceLinkGenerated: false,
  isEditLinkConfirmationOpen: false,
  showGenerateSchedulerLink: false,
  showAddModeratorsModal: false,
  showTimeRangeModal: false,
  showUnableToRemoveModModal: false,
  moderatorId: '',
  selectedModeratorTimeRange: {},
  moderatorsScheduledInterviews: [],
  showUnableToRemoveModErrorMessage: false,
  modifiedModerators: [],
  flag: '',
  defaultModerators: [],
  messageKey: '',
  interviewBufferIsSubmitting: false,
  istranslationModalOpen: false,
  meetingInformationMap: new Map(),
  editedMeetingInformationMap: new Map(),
  languageAndLocalizationArray: [],  
  languageAndLocalizationMap: new Map (),
  languages: new Map(),
  topicNamelanguages: new Map(),
  localizationMap: new Map(),
  topicNamelocalizationMap: new Map(),
  defaultLocalizationMap: new Map(),
  chosenTranslations: new Map([["en_us", { id: 0, country: "united states", country_code: "us", language_name: "English", language_code: "en", langCode_countryCode: "en_us" }]]),
  chosenTranslationsLabels: '',
  translationsToDelete: [],
  translationsTopicToDelete:[],
  toggleModal: false,
  toggleTranslationsModal: false,
  toggleTopicTransltionsModal: false,
  chosenTopicNameData: new Map (),
  topicNameTranslations: new Map (),
  topicNameDetails: new Map (),
  editedTopicNameDetails: new Map(),
  isSubmittingTopicName: false,
  canNotBeEdited: new Map(),
}


const transfromArraytoMap = (state,array) => {
  let map = new Map ()
  array.map(item => {
    state = map.set(item.langCode_countryCode?item.langCode_countryCode : item[0] ,item[0] ? item [1]: item )
  })
  return state 
}

const setMeetingInfromationMap = (editedMeetingInformationMap, payload, clear) => {
  if (editedMeetingInformationMap && payload) {
    if (clear === false) {
      if (payload.langCode_countryCode) {
        editedMeetingInformationMap.set(payload.langCode_countryCode, payload.value)
      } else if (payload) {
        payload.map(item => editedMeetingInformationMap.set(item[0], item[1]))
      }
    }
    else {
      editedMeetingInformationMap.clear()
      payload.map(item => editedMeetingInformationMap.set(item[0], item[1]))

    }
  }
  return editedMeetingInformationMap
}

const setChosenTranslations = (state, languageAndLocalizationArray, editedMeetingInformationMap, payload) => {
  languageAndLocalizationArray.map(item => {
    if (payload.localizationCode) {
      const langCountry = payload.languageCode + '_' + payload.localizationCode
      if (langCountry === item.langCode_countryCode) {
          state.set(item.langCode_countryCode, item)
          editedMeetingInformationMap &&  editedMeetingInformationMap.set(item.langCode_countryCode, "")
      }
    } else {
      if (payload.languageCode === item.language_code) {
        state.set(item.langCode_countryCode, item)
        editedMeetingInformationMap &&  editedMeetingInformationMap.set(item.langCode_countryCode, "")
      }
    }
  })
  return state
}

const setExistingTranslations = (state, languageAndLocalizationArray, payload) => {
  state.clear()
  let existingTranslationsMap = new Map(payload)
  if (payload[0]) {
    languageAndLocalizationArray.map(item => {
      if (existingTranslationsMap.has(item.langCode_countryCode)) {
        state.set(item.langCode_countryCode, item)
      }
    })
  }

  return state
}

const setLanguages = (state, localization, payload) => {
  if (payload.localizationCode) {
    const localizationMap = [...localization.values()]
    if (localizationMap.filter(item => item.language_code === payload.languageCode).length === 0) {
      state.delete(payload.languageCode)
    }
  } else {
    state.delete(payload.languageCode)
    return state
  }
  return state
}

const setExistingLanguages = (state, localizationMap,payload) => {
  if (payload[0]) {
    let existingLanguagesMap = new Map(payload)
    const newLocalizationMap = [...localizationMap.values()]
    existingLanguagesMap.forEach((value, key) => {
      if (newLocalizationMap.filter(item => item.language_code === key.slice(0, 2).toString()).length === 0) {
        state.delete(key.slice(0, 2))
      }
    })
  }
  return state
}


const setLocalizationMap = (state, payload) => {
  if (payload.localizationCode) {
    const langCountry = payload.languageCode + '_' + payload.localizationCode
    state.delete(langCountry)
  }
  return state
}

const setExistingLocalizationMap = (state, payload) => {
  if (payload[0]) {
    let existingLocalizationMap = new Map(payload)
    existingLocalizationMap.forEach((value, key) => {
      state.delete(key)
    }
    )
  }
  return state
}

const setAllLanguages = (state, payload) => {
  if (payload) {
    payload.map(item => state.set(item.language_code, item))
  }
  return state
}

const setAllLocalizationMap = (state, payload) => {
  if (payload) {
    payload.map(item => state.set(item.langCode_countryCode, item))
  }
  return state
}

const deleteTranslations = (state, payload) => {
  if (payload) {
    state.delete(payload)
  }
  return state
}

const addLocalizationMap = (state,defaultLocalizationMap, payload) => {
  if (payload) {
    const itemToAdd = defaultLocalizationMap.get(payload)
    itemToAdd && state.set(itemToAdd.langCode_countryCode, itemToAdd)
  }
  return state
}


const addLanguages = (state,languageAndLocalizationArray, payload) => {
  if (payload) {
      languageAndLocalizationArray.map(item => {
      if (item.langCode_countryCode === payload) {
        state.set(item.language_code, { language_code: item.language_code, language_name: item.language_name })
      }
    })
  }
  return state
}

const projectReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ALL_NECESSARY_PROJECT_INFO_SUCCEEDED:
      let shared = {
        ...state,
        ...action.payload,
        topicNameDetails:  action.payload.topicNameDetails ? transfromArraytoMap(state.topicNameDetails,action.payload.topicNameDetails) : state.topicNameDetails.set('en_us', action.payload.name ),
        editedTopicNameDetails: action.payload.topicNameDetails ? transfromArraytoMap(state.topicNameDetails,action.payload.topicNameDetails) : state.topicNameDetails.set('en_us', action.payload.name ),
        topicNameDefault: state.topicNameDetails.get('en_us'),
        topicNameTranslations:  action.payload.topicNameDetails 
                                    ? setExistingTranslations(state.topicNameTranslations, state.languageAndLocalizationArray, action.payload.topicNameDetails) 
                                    : new Map([["en_us", { id: 0, country: "united states", country_code: "us", language_name: "English", language_code: "en", langCode_countryCode: "en_us" }]]),
        topicNamelocalizationMap: setExistingLocalizationMap(state.topicNamelocalizationMap, action.payload.topicNameDetails),
        topicNamelanguages: setExistingLanguages(state.topicNamelanguages, state.topicNamelocalizationMap, action.payload.topicNameDetails),
        canNotBeEdited: transfromArraytoMap(state.canNotBeEdited, action.payload.canNotBeEdited)
      }
      if (action.payload.conferenceLinkData && action.payload.conferenceLinkData.conference_link && action.payload.conferenceLinkData.conference_link.length > 0) {
        return {
          ...shared,
          showCopyLinkButton: true,
          conferenceLink: action.payload.conferenceLinkData.conference_link,
          editedConferenceLink: action.payload.conferenceLinkData.conference_link,
          conferenceLinkGenerated: true,
          showGenerateSchedulerLink: action.payload.schedulerGenerated,
          generatedLink: `${window.location.host}/scheduler/user/${action.payload.userId}/qstool/${action.payload.surveyId}`,
          meetingInformationMap: setMeetingInfromationMap(state.meetingInformationMap, action.payload.conferenceLinkData.meetingInformation, true),
          editedMeetingInformationMap: setMeetingInfromationMap(state.editedMeetingInformationMap, action.payload.conferenceLinkData.meetingInformation, true),
          chosenTranslations: setExistingTranslations(state.chosenTranslations, state.languageAndLocalizationArray ,action.payload.conferenceLinkData.meetingInformation),
          localizationMap: setExistingLocalizationMap(state.localizationMap, action.payload.conferenceLinkData.meetingInformation),
          languages: setExistingLanguages(state.languages, state.localizationMap, action.payload.conferenceLinkData.meetingInformation),
          isSubmittingConferenceLink: false,
        }
      } else if (state.conferenceLinkGenerated) {
        return {
          ...shared,
          showCopyLinkButton: true,
          conferenceLink: state.conferenceLink || '',
          editedConferenceLink: state.conferenceLink || '',
          conferenceLinkGenerated: false,
          enableGenerateSchedulerButton: state.conferenceLink && state.conferenceLink.length > 0,
          isSubmittingConferenceLink: false,
          showGenerateSchedulerLink: action.payload.schedulerGenerated,
          generatedLink: action.payload.schedulerGenerated
            ? `${window.location.host}/scheduler/user/${action.payload.userId}/qstool/${action.payload.surveyId}`
            : '',
          meetingInformationMap: state.meetingInformationMap,
          editedMeetingInformationMap: state.editedMeetingInformationMap,
          chosenTranslations: state.chosenTranslations,
          localizationMap: state.localizationMap,
          languages: state.languages,
        }
      } else if (action.payload.conferenceLinkData && action.payload.conferenceLinkData.meetingInformation && action.payload.conferenceLinkData.meetingInformation.length > 0) {
        return {
          ...shared,
          showCopyLinkButton: true,
          conferenceLink: '',
          editedConferenceLink: '',
          conferenceLinkGenerated: false,
          enableGenerateSchedulerButton: false,
          isSubmittingConferenceLink: false,
          showGenerateSchedulerLink: action.payload.schedulerGenerated,
          generatedLink: action.payload.schedulerGenerated
            ? `${window.location.host}/scheduler/user/${action.payload.userId}/qstool/${action.payload.surveyId}`
            : '',
          meetingInformationMap: setMeetingInfromationMap(state.meetingInformationMap, action.payload.conferenceLinkData.meetingInformation, true),
          editedMeetingInformationMap: setMeetingInfromationMap(state.editedMeetingInformationMap, action.payload.conferenceLinkData.meetingInformation, true),
          chosenTranslations: setExistingTranslations(state.chosenTranslations, state.languageAndLocalizationArray, action.payload.conferenceLinkData.meetingInformation),
          localizationMap: setExistingLocalizationMap(state.localizationMap, action.payload.conferenceLinkData.meetingInformation),
          languages: setExistingLanguages(state.languages, state.localizationMap, action.payload.conferenceLinkData.meetingInformation),
        }
      } else {
        return {
          ...shared,
          showCopyLinkButton: false,
          enableGenerateSchedulerButton: false,
          conferenceLinkGenerated: false,
          showGenerateSchedulerLink: action.payload.schedulerGenerated,
          generatedLink: action.payload.schedulerGenerated
            ? `${window.location.host}/scheduler/user/${action.payload.userId}/qstool/${action.payload.surveyId}`
            : '',
          meetingInformationMap: setMeetingInfromationMap(state.meetingInformationMap, [['en_us', '']], true),
          editedMeetingInformationMap: setMeetingInfromationMap(state.editedMeetingInformationMap, [['en_us', '']], true),
          conferenceLink: '',
          editedConferenceLink: '',
          isSubmittingConferenceLink: false,
          chosenTranslations: new Map([["en_us", { id: 0, country: "united states", country_code: "us", language_name: "English", language_code: "en", langCode_countryCode: "en_us" }]]),
        }
      }
    case types.PUT_PROJECT_STATUS_SUCCEEDED:
      return { ...state, ...action.payload }
    case types.CHANGE_MODERATOR_REQUESTED:
      return {
        ...state,
        asyncOps: {
          ...state.asyncOps,
          moderator: true,
        },
      }
    case types.POST_CONFERENCE_LINK_DETAILS_REQUESTED:
      return {
        ...state,
        isSubmittingConferenceLink: true,
        editedConferenceLink: action.editedConferenceLink,
        editedMeetingInformationMap: action.editedMeetingInformationMap
      }
    case types.POST_CONFERENCE_LINK_DETAILS_SUCCESSED:
      return {
        ...state,
        showCopyLinkButton: true,
        conferenceLink: action.conferenceLink,
        enableGenerateSchedulerButton: true,
        isSubmittingConferenceLink: false,
        conferenceLinkGenerated: true,
        showGenerateSchedulerLink: false,
        meetingInformationMap: setMeetingInfromationMap(state.meetingInformationMap, action.editedMeetingInformationMap, true),
        translationsToDelete: [],
      }
    case types.POST_CONFERENCE_LINK_DETAILS_FAILED:
      return {
        ...state,
        showCopyLinkButton: false,
        isSubmittingConferenceLink: false,
      }
    case types.UPDATE_CONFERENCE_LINK_DETAILS_REQUESTED:
      return {
        ...state,
        isSubmittingConferenceLink: true,
        editedConferenceLink: action.payload.conferenceLink,
        editedMeetingInformationMap: action.payload.editedMeetingInformationMap
      }
    case types.UPDATE_CONFERENCE_LINK_DETAILS_SUCCESSED:
      return {
        ...state,
        showCopyLinkButton: true,
        enableGenerateSchedulerButton: true,
        conferenceLinkGenerated: true,
        isSubmittingConferenceLink: false,
        conferenceLink: action.payload.conferenceLink,
        editedConferenceLink: action.payload.conferenceLink,
        meetingInformationMap: setMeetingInfromationMap(state.meetingInformationMap, Array.from(action.payload.editedMeetingInformationMap.entries()), true),
        editedMeetingInformationMap: setMeetingInfromationMap(state.editedMeetingInformationMap, Array.from(action.payload.editedMeetingInformationMap.entries()), true),
        translationsToDelete: [],
      }
    case types.UPDATE_CONFERENCE_LINK_DETAILS_FAILED:
      return {
        ...state,
        isSubmittingConferenceLink: false,
      }
    case types.CHANGE_MODERATOR_SUCCEEDED:
      return {
        ...state,
        qualModeratorId: action.payload,
        asyncOps: {
          ...state.asyncOps,
          moderator: false,
        },
      }
    case types.CHANGE_MODERATOR_FAILED:
      return {
        ...state,
        asyncOps: {
          ...state.asyncOps,
          moderator: false,
        },
      }
    case types.LAUNCH_SURVEYS_REQUESTED:
      return { ...state, isLaunching: true }
    case types.LAUNCH_SURVEYS_FAILED:
      return { ...state, isLaunching: false }
    case types.LAUNCH_SURVEYS_SUCCEEDED:
      return {
        ...state,
        isLaunching: false,
        projectStatus: 'In Progress',
        projectStatusId: 3,
        surveys: state.surveys.map(s => ({
          ...s,
          status: {
            status: s.status.status === 3 ? 2 : 1,
            label: s.status.status === 3 ? 'Re-Fielding' : 'Fielding',
          },
        })),
      }
    case types.CLOSE_SURVEYS_REQUESTED:
      return { ...state, isLaunching: true }
    case types.CLOSE_SURVEYS_FAILED:
      return { ...state, isLaunching: false }
    case types.CLOSE_SURVEYS_SUCCEEDED:
      return {
        ...state,
        isLaunching: false,
        surveys: state.surveys.map(s => ({
          ...s,
          status: {
            status: 3,
            label: 'Closed',
          },
        })),
      }
    case types.ADD_OBSERVERS_TO_PROJECT_SUCCEEDED:
      return {
        ...state,
        observerEmails: action.payload,
      }
    case types.TOGGLE_PAUSE_WARNING_REQUESTED:
      return { ...state, pauseWarningOpen: !state.pauseWarningOpen }
    case types.TOGGLE_EDIT_WARNING_REQUESTED:
      return { ...state, editWarningOpen: !state.editWarningOpen }
    case types.TOGGLE_PROJECT_COMPLETE_WARNING:
      return { ...state, projectCompleteWarningOpen: !state.projectCompleteWarningOpen }
    case types.INIT_LAUNCH_SURVEYS_REQUESTED:
      return {
        ...state,
        completionsWarningOpen: moreCompletionsNeededThanAvailableSlots(state.surveys, state.availabilityCount),
      }
    case types.TOGGLE_COMPLETIONS_WARNING_REQUESTED:
      return { ...state, completionsWarningOpen: !state.completionsWarningOpen }
    case types.CLEAR_PROJECT_INQUIRY:
    case types.NEW_PROJECT_CREATED:
      return initialState
    case types.FINALIZE_PROJECT_SUCCEEDED:
      return { ...state, ...action.payload }
    case types.REOPEN_PROJECT_SUCCEEDED:
      return { ...state, ...action.payload }
    case types.FETCH_ALL_DASHBOARD_INFO_SUCCEEDED:
      return { ...state, ...action.payload }
    case types.UPDATE_PROJECT_MODERATORS_REQUESTED:
      return { ...state, isSubmitting: true }
    case types.UPDATE_PROJECT_MODERATORS_SUCCEEDED:
      return { ...state, dashboardInfo: { moderatorInfo: action.payload }, isSubmitting: false }
    case types.TOGGLE_ADD_MODERATORS_MODAL:
      return {
        ...state,
        showAddModeratorsModal: !state.showAddModeratorsModal,
        modifiedModerators: action.payload ? action.payload.modifiedModerators : [],
        moderatorsScheduledInterviews: action.payload ? action.payload.moderatorsScheduledInterviews : [],
        defaultModerators: action.payload ? action.payload.defaultModerators : [],
        status: action.payload ? action.payload.status : '',
        defaultModeratorsDetails: action.payload ? action.payload.defaultModeratorsDetails : [],
        messageKey: action.payload ? action.payload.messageKey : '',
      }
    case types.TOGGLE_TIME_RANGE_MODAL:
      return {
        ...state, showTimeRangeModal: !state.showTimeRangeModal, moderatorId: action.payload.moderatorId,
        selectedModeratorTimeRange: {
          startTime: action.payload.selectedModeratorTimeRange ? action.payload.selectedModeratorTimeRange.startTime : action.payload.selectedModeratorTimeRange,
          endTime: action.payload.selectedModeratorTimeRange ? action.payload.selectedModeratorTimeRange.endTime : action.payload.selectedModeratorTimeRange,
          timezone: action.payload.selectedModeratorTimeRange ? action.payload.selectedModeratorTimeRange.timezone : state.selectedModeratorTimeRange.timezone
        },
        timeRangeSubmitting: false
      }
    case types.TOGGLE_UNABLE_TO_REMOVE_MOD_MODAL:
      return {
        ...state,
        showUnableToRemoveModModal: !state.showUnableToRemoveModModal,
        moderatorsScheduledInterviews: action.payload ? action.payload : [],
        showUnableToRemoveModErrorMessage: action.showUnableToRemoveModErrorMessage ? action.showUnableToRemoveModErrorMessage : false,
        flag: action.flag ? action.flag : '',
        modifiedModerators: action.modifiedModerators ? action.modifiedModerators : [],
        defaultModerators: action.defaultModerators ? action.defaultModerators : [],
        status: action.status ? action.status : '',
        defaultModeratorsDetails: action.defaultModeratorsDetails ? action.defaultModeratorsDetails : [],
        messageKey: action.messageKey ? action.messageKey : '',
        isSubmitting: false
      }
    case types.PUT_MODERATOR_TIME_RANGE_SUCCESSED:
      return { ...state, moderatorId: action.payload.moderatorInfo.id, selectedModeratorTimeRange: { startTime: action.payload.moderatorInfo.startTime, endTime: action.payload.moderatorInfo.endTime }, timeRangeSubmitting: false }
    case types.PUT_MODERATOR_TIME_RANGE_RQUESTED:
      return { ...state, timeRangeSubmitting: true }
    case types.PUT_MODERATOR_TIME_RANGE_FAILED:
      return { ...state, timeRangeSubmitting: false }
    case types.EDIT_SAMPLE_SIZE_SUCCEEDED:
      return {
        ...state,
        surveys: state.surveys.map(survey => {
          if (survey.id === action.payload.id)
            return { ...action.payload }

          return survey
        }),
      }
    case types.UPDATE_PROJECT_SAMPLE_SIZE_SUCCESSED:
    case types.UPDATE_PROJECT_SAMPLE_SIZE_FAILED:
      return {
        ...state,
        isSubmitting: false,
        showWarningBanner: action.payload.showWarningBanner
      }
    case types.UPDATE_PROJECT_MODERATORS_FAILED:
      return {
        ...state,
        isSubmitting: false,
        showAddModeratorsModal: false
      }
    case types.UPDATE_PROJECT_SAMPLE_SIZE_REQUESTED:
      return {
        ...state,
        sampleSize: action.payload.sampleSize,
        isSubmitting: true,
      }
    case types.TOGGLE_EDIT_CONFERENCE_LINK_CONFIRMATION_MODAL:
      return {
        ...state,
        isEditLinkConfirmationOpen: action.isOpen,
        editedConferenceLink: action.editedConferenceLink,
        editedMeetingInformationMap: action.editedMeetingInformationMap
      }
    case types.UPDATE_PROJECT_INFO_REQUESTED:
      return {
        ...state,
        isSubmitting: true,
      }
    case types.UPDATE_PROJECT_INFO_SUCCESSED:
      return {
        ...state,
        showGenerateSchedulerLink: true,
        isSubmitting: false,
        generatedLink: `${window.location.host}/scheduler/user/${action.userId}/qstool/${state.surveyId}`
      }
    case types.UPDATE_PROJECT_INFO_FAILED:
      return {
        ...state,
        showGenerateSchedulerLink: false,
        isSubmitting: false,
      }
    case types.UPDATE_PROJECT_SURVEY_ID_REQUESTED:
      return {
        ...state,
        isSubmitting: true,
      }
    case types.UPDATE_INTERVIEW_BUFFER_REQUESTED:
      return {
        ...state,
        interviewBufferIsSubmitting: true,
      }
    case types.UPDATE_INTERVIEW_BUFFER_SUCCESSED:
      if (action.payload.flag === "postScreeninBuffer") {
        return {
          ...state,
          interviewBufferIsSubmitting: false,
          postScreeninBuffer: action.payload.value
        }
      }
      else {
        return {
          ...state,
          interviewBufferIsSubmitting: false,
          moderatorBuffer: action.payload.value
        }
      }
    case types.UPDATE_INTERVIEW_BUFFER_FAILED:
      return {
        ...state,
        interviewBufferIsSubmitting: false,
      }
    case types.UPDATE_PROJECT_SURVEY_ID_SUCCESSED:
      return {
        ...state,
        isSubmitting: false,
        externalSurveyId: action.surveyId
      }
    case types.UPDATE_PROJECT_SURVEY_ID_FAILED:
      return {
        ...state,
        isSubmitting: false,
      }
    case types.GET_AVAILABLE_MODERATORS_COUNT_REQUESTED:
      return {
        ...state,
        isSubmitting: true,
      }
    case types.GET_AVAILABLE_MODERATORS_COUNT_FAILED:
    case types.GET_AVAILABLE_MODERATORS_COUNT_SUCCESSED:
      return {
        ...state,
        isSubmitting: false,
        showWarningBanner: action.payload.showWarningBanner,
      }
    case types.GET_UNAVAILABLE_MODERATORS_REQUESTED:
      return {
        ...state,
        isSubmitting: true,
      }
    case types.GET_UNAVAILABLE_MODERATORS_FAILED:
      return {
        ...state,
        isSubmitting: false,
      }
    case types.GET_UNAVAILABLE_MODERATORS_SUCCESSED:
      return {
        ...state,
        isSubmitting: false,
        displayWarning: action.payload.displayWarning,
        displayError: action.payload.displayError,
      }

    case types.DELETE_PROJECT_MODERATOR_SUCCEEDED:
      return { ...state, dashboardInfo: { moderatorInfo: action.payload }, isSubmitting: false }
    case types.TOGGLE_TRANSLATIONS_MODAL:
      return { ...state, 
        istranslationModalOpen: !state.istranslationModalOpen, 
        editedConferenceLink: action.payload, 
        editedMeetingInformationMap:action.editedMeetingInformation, 
        editedTopicNameDetails: action.editedTopicName }
    case types.ADD_TRANSLATIONS_REQUESTED:
      let commun = {
        ...state,
        localizationCode: action.payload.localizationCode,
        languageCode: action.payload.languageCode,
        istranslationModalOpen: !state.istranslationModalOpen,
        editedTopicNameDetails: action.payload.editedTopicName,
      }
      if (action.payload.flag === 'meetingInformation') {
        return {
          ...commun,
          chosenTranslations: setChosenTranslations(state.chosenTranslations, state.languageAndLocalizationArray, state.editedMeetingInformationMap, action.payload),
          localizationMap: setLocalizationMap(state.localizationMap, action.payload),
          languages: setLanguages(state.languages, state.localizationMap, action.payload),
          editedConferenceLink: action.payload.editedConferenceLink,
          editedMeetingInformationMap: action.payload.editedMeetingInformation,
        }
      } else if (action.payload.flag === 'topicName') {
        return {
          ...commun,
          topicNameTranslations: setChosenTranslations(state.topicNameTranslations, state.languageAndLocalizationArray, state.editedMeetingInformationMap, action.payload),
          topicNamelocalizationMap: setLocalizationMap(state.topicNamelocalizationMap, action.payload),
          topicNamelanguages: setLanguages(state.topicNamelanguages, state.topicNamelocalizationMap, action.payload),
          editedTopicNameDetails: action.payload.editedTopicName,
          editedMeetingInformationMap: state.editedMeetingInformationMap
        }
      }
    case types.SET_MEETING_INFORMATION_PER_LANGUAGE:
      return {
        ...state,
        editedMeetingInformationMap: setMeetingInfromationMap(state.editedMeetingInformationMap, action.payload.payload, false),
        editedConferenceLink: action.payload.editedConferenceLink
      }
    case types.GET_LANG_LOC_SUCCESSED:
      return {
        ...state,
        localizationMap: setAllLocalizationMap(state.localizationMap, action.payload.getCountriesWithLocalisations),
        topicNamelocalizationMap: setAllLocalizationMap(state.topicNamelocalizationMap, action.payload.getCountriesWithLocalisations),
        languages: setAllLanguages(state.languages, action.payload.getDataFromLanguageLocalisation),
        topicNamelanguages:setAllLanguages(state.topicNamelanguages, action.payload.getDataFromLanguageLocalisation),
        languageAndLocalizationArray: action.payload.getAllLanguageLocalisations,
        languageAndLocalizationMap:transfromArraytoMap(state.languageAndLocalizationMap ,action.payload.getAllLanguageLocalisations),
        defaultLocalizationMap: setAllLocalizationMap(state.defaultLocalizationMap, action.payload.getCountriesWithLocalisations)
      }
    case types.CLEAR_TRANSLATIONS:
      if (action.payload.flag === 'meetingInformation') {
        return {
          ...state,
          meetingInformationMap: setMeetingInfromationMap(state.meetingInformationMap, Array.from(state.meetingInformationMap.entries()), true),
          editedMeetingInformationMap: setMeetingInfromationMap(state.meetingInformationMap, Array.from(state.meetingInformationMap.entries()), true),
          chosenTranslations: setExistingTranslations(state.chosenTranslations, state.languageAndLocalizationArray, state.meetingInformationMap),
          localizationMap: setExistingLocalizationMap(state.localizationMap, state.meetingInformationMap),
          languages: setExistingLanguages(state.languages, state.languageAndLocalizationArray, state.meetingInformationMap),
          isSubmittingConferenceLink: false,
          chosenTranslationsLabels: '',
          translationsToDelete: []
        }
      } else if (action.payload.flag === 'topicName') {
        return {
          ...state,
          editedTopicNameDetails: state.topicNameDetails,
          topicNamelocalizationMap: setExistingLocalizationMap(state.topicNamelocalizationMap, state.topicNameDetails),
          topicNamelanguages: setExistingLanguages(state.topicNamelanguages, state.topicNamelocalizationMap, state.topicNameDetails),
          topicNameTranslations: setExistingTranslations(state.topicNameTranslations, state.languageAndLocalizationArray, state.topicNameDetails),
          translationsTopicToDelete: [],
        }
      }
    case types.SET_CHOSEN_TRANLSATIONS_LABELS:
      return {
        ...state,
        chosenTranslationsLabels: action.payload
      }
    case types.DELETE_TRANSLATIONS_FAILED:
    case types.DELETE_TRANSLATIONS_REQUESTED:
      return {
        ...state,
        editedMeetingInformationMap: action.payload.editedMeetingInformation,
        editedConferenceLink: action.payload.editedConferenceLink
      }
    case types.DELETE_TRANSLATIONS_SUCCESSED:
      return {
        ...state,
        editedMeetingInformationMap: deleteTranslations(state.editedMeetingInformationMap, action.payload.translationsToDelete),
        chosenTranslations: deleteTranslations(state.chosenTranslations, action.payload.translationsToDelete),
        localizationMap: addLocalizationMap(state.localizationMap,state.defaultLocalizationMap ,action.payload.translationsToDelete),
        languages: addLanguages(state.languages,state.languageAndLocalizationArray, action.payload.translationsToDelete),
        editedMeetingInformationMap: action.payload.editedMeetingInformation,
        editedConferenceLink: action.payload.editedConferenceLink,
        translationsToDelete: [...state.translationsToDelete, action.payload.translationsToDelete]
      }
      case types.DELETE_TOPIC_TRANSLATIONS_FAILED:
      case types.DELETE_TOPIC_TRANSLATIONS_REQUESTED:
      return {
        ...state,
        editedTopicNameDetails: action.payload.editedTopicName,
      }
      case types.DELETE_TOPIC_TRANSLATIONS_SUCCESSED:
      return {
        ...state,
        editedTopicNameDetails: deleteTranslations(state.editedTopicNameDetails, action.payload.translationsToDelete),
        topicNameTranslations: deleteTranslations(state.topicNameTranslations, action.payload.translationsToDelete),
        topicNamelocalizationMap: addLocalizationMap(state.topicNamelocalizationMap,state.defaultLocalizationMap, action.payload.translationsToDelete),
        topicNamelanguages: addLanguages(state.topicNamelanguages,state.languageAndLocalizationArray, action.payload.translationsToDelete),
        editedTopicName: action.payload.editedTopicName,
        translationsTopicToDelete: [...state.translationsTopicToDelete, action.payload.translationsToDelete],
      }
    case types.TOGGLE_INCONSISTENT_MEETING_INFORMATION_MODAL:
      return {
        ...state,
        toggleModal: !state.toggleModal,
        editedMeetingInformationMap: action.payload.editedMeetingInformation,
        editedConferenceLink: action.payload.editedConferenceLink
      }
    case types.TOGGLE_TRANSLATIONS_ERROR_MODAL:
      return {
        ...state,
        toggleTranslationsModal: !state.toggleTranslationsModal,
        editedMeetingInformationMap: action.payload.editedMeetingInformation,
        editedConferenceLink: action.payload.editedConferenceLink
      }

      case types.TOGGLE_TOPIC_TRANSLATIONS_ERROR_MODAL:
      return {
        ...state,
        toggleTopicTransltionsModal: !state.toggleTopicTransltionsModal,
        editedTopicName: action.payload.editedTopicName
      }
      
      case types.ADD_TOPIC_NAME_TRANSLATIONS_SUCCESSED:
        return {
          ...state,
          editedTopicNameDetails: action.payload.editedTopicName,
          isSubmittingTopicName: false,
          topicNameDetails: action.payload.editedTopicName,
        }
        case types.ADD_TOPIC_NAME_TRANSLATIONS_REQUESTSED:
          return {
            ...state,
            isSubmittingTopicName: true,
            editedTopicNameDetails: action.payload.editedTopicName,
          }   
        case types.ADD_TOPIC_NAME_TRANSLATIONS_FAILED:
            return {
              ...state,
              isSubmittingTopicName: false,
            }   
    default:
      return state
  }
}

export default projectReducer
